import {FormControl, InputLabel, MenuItem, Select, styled} from '../../../ui-library';

export const StyledFormControl = styled(FormControl)`
    font-size: 12px;
    margin-top: 10px;
`;

export const StyledSelect = styled(Select)(({ theme }) => ({
    backgroundColor: '#374151',
    '& .MuiSelect-select': {
        backgroundColor: '#374151',
        borderRadius: 5,
        color: '#f0f0f0',
        fontSize: '16px', // Keep the top select text size
    },
    '& .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.grey[500],
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.grey[500],
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: '#90CAF9',
    },
    '& .MuiSelect-icon': {
        color: theme.palette.grey[300],
    },
    borderRadius: 5,
    height: '40px',
}));


export const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
    paddingTop: '10px',
    display: 'flex',
    justifyContent: 'space-between',
    fontSize: '14px',
    color: '#f0f0f0',
    backgroundColor: theme.palette.grey[500],
    '&.Mui-selected': {
        backgroundColor: theme.palette.grey[500] + ' !important',
        color: '#f0f0f0',
        '&:hover': {
            backgroundColor: theme.palette.grey[500] + ' !important',
        },
    },
    '&.Mui-focused': {
        backgroundColor: theme.palette.grey[500] + ' !important', // Ensure focused item has the same color
        color: '#f0f0f0', // Keep text color unchanged on focus
    },
    '&:hover': {
        backgroundColor: theme.palette.grey[500],
        color: '#f0f0f0',
    },
    '&.Mui-disabled': {
        backgroundColor: theme.palette.grey[500],
        color: '#b0b0b0',
    },
}));

export const StyledInputLabel = styled(InputLabel)(({ theme }) => ({
    color: theme.palette.grey[300],
    '&.Mui-focused': {
        color: '#90CAF9',
    },
}));
